export const returnToApplicationErrorMessages = [
  'There is already an account with that phone number.',
  'There is already an account with that email address.',
  'そのメールアドレスではすでにアカウントが存在します。',
  'その電話番号ではすでにアカウントが存在します。',
  'Es gibt bereits ein Konto mit dieser E-Mail-Adresse.',
  'Un compte est déjà associé à cette adresse courriel.',
  'Ya hay una cuenta con esa dirección de correo electrónico.',
]
